import { graphql } from '@tn/foundation/graphql/__generated/gql';

export const rendezvousCacheKey = 'rendezvous';
export const formRendezvousDocument = /* GraphQL */ `
    mutation FormRendezvousUpload($formFields: FormRendezvousFields!) {
        formRendezvousUpload(formFields: $formFields) {
            message
            activationCode
            activationScreen
            device {
                name
                partner
            }
            success
        }
    }
`;
export const formRendezvousMutation = graphql(formRendezvousDocument);
